import React from 'react';
import { BatchesApprovedContainer } from '../../../containers';

export const BatchesApproved = () => <BatchesApprovedContainer />;
